import { GRANULARITY } from '@adtrackify/at-tracking-event-types';

import * as Logger from '@/lib/monitoring/logger';
import {
  isDateRangeLongerThan,
} from '@/lib/helpers/dates/date-ranges';
import type {
  DateRangeState,
} from '@/lib/types/date-range-types';

export function validateGranularity(
  requested: GRANULARITY,
  dateRange: DateRangeState,
  context: string
): GRANULARITY {
  if (requested === GRANULARITY.HOUR && isDateRangeLongerThan(dateRange, 1)) {
    Logger.debug('Hourly granularity invalid, defaulting to daily', { context });
    return GRANULARITY.DAY;
  }
  return requested;
}

const COHORT_VIEW_IDS = new Set<string>(['ltv-cohort-dashboard']);

const COHORT_PATH_FRAGMENTS = ['ltv-cohort', 'cohort'];

export function isCohortView(viewId: string): boolean {
  if (COHORT_VIEW_IDS.has(viewId)) {
    return true;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  const { pathname } = window.location;
  return COHORT_PATH_FRAGMENTS.some(fragment => pathname.includes(fragment));
}
